export default __webpack_public_path__ + "191dcf8d7da243ddac3694e22fe10e67.svg";